import { Mutation } from '@apollo/react-components';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import styles from 'styles/partials/_view-option.css';

import deleteQuery from 'graphql/mutations/dashboard/DashboardDeleteMutation.graphql';
import setPrimaryQuery from 'graphql/mutations/dashboard/DashboardSetPrimaryMutation.graphql';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getClientMutationId from '../../utils/getClientMutationId';

export default class ViewOption extends Component {
  constructor(props) {
    super(props);

    this.renderDefaultGlyph = this.renderDefaultGlyph.bind(this);
  }

  renderDefaultGlyph(viewId) {
    if (this.props.option.isDefault || this.props.option.description === 'default') {
      //This check only works for views, not dashboards.
      return (
        <span
          className={'icon ' + styles['defaultView']}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          star_border
        </span>
      );
    } else if (this.props.option.type === 'DASHBOARD') {
      return (
        <Mutation mutation={setPrimaryQuery} onCompleted={this.props.onMutationComplete}>
          {(setPrimary) => {
            return (
              <span
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  let inputVariables = normalizeVariables({
                    variables: {
                      input: {
                        clientMutationId: getClientMutationId(),
                        id: viewId,
                      },
                    },
                  });

                  setPrimary(inputVariables);
                }}
              >
                star_border
              </span>
            );
          }}
        </Mutation>
      );
    } else {
      return (
        <span
          className="icon"
          onClick={(e) => {
            e.stopPropagation();
            this.props.option.onSetAsDefault(viewId);
          }}
        >
          star_border
        </span>
      );
    }
  }

  renderDeleteGlyph(viewId) {
    if (this.props.option.description === 'default') return null;
    if (!this.props.deletable) return null;

    if (this.props.option.type === 'DASHBOARD') {
      return (
        <Mutation mutation={deleteQuery} onCompleted={() => this.props.onDeleteComplete(this.props.option.description)}>
          {(deleteDashboard) => {
            return (
              <span
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();

                  let inputVariables = normalizeVariables({
                    variables: {
                      input: {
                        clientMutationId: getClientMutationId(),
                        id: viewId,
                      },
                    },
                  });

                  deleteDashboard(inputVariables);
                }}
              >
                {this.props.option.description === 'Default' ? 'restore_page' : 'delete'}
              </span>
            );
          }}
        </Mutation>
      );
    } else {
      return (
        <span
          className="icon"
          onClick={(e) => {
            e.stopPropagation();
            this.props.option.onDelete(viewId);
          }}
        >
          delete
        </span>
      );
    }
  }

  render() {
    let highlight = this.props.highlight;
    let shared = this.props.option.shared;
    let description = this.props.option.description;
    let viewId = this.props.option.id;
    let glyphs = null;

    if (highlight && this.props.deletable) {
      glyphs = (
        <Fragment>
          <div className={styles['icon']}>{this.renderDefaultGlyph(viewId)}</div>
          <div className={styles['icon']}>{this.renderDeleteGlyph(viewId)}</div>
        </Fragment>
      );
    }

    return (
      <div
        className={highlight ? styles['optionHighlight'] : shared ? styles['optionShared'] : styles['option']}
        data-testid={this.props['data-testid']}
      >
        <div className={styles['iconContainer']}>
          <div className={styles['description']}>{description}</div>
          {glyphs}
        </div>
      </div>
    );
  }
}

ViewOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string.isRequired,
    onSetAsDefault: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }),
  highlight: PropTypes.bool,
  deletable: PropTypes.bool,
  onDeleteComplete: PropTypes.func,
  onMutationComplete: PropTypes.func,
};

ViewOption.defaultProps = {
  deletable: true,
  onDeleteComplete: () => {},
  onMutationComplete: () => {},
};
